/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event.detail.overview', {
            parent: 'board.dinghy.event.detail',
            url: '/home',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY'],
                pageTitle: 'askApp.dinghyEvent.detail.homeTitle'
            },
            views: {
                'dinghyDetail@board.dinghy.event.detail': {
                    templateUrl: 'app/board/dinghy/event/detail/overview/dinghy-event-overview.html',
                    controller: 'DinghyEventOverviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.dinghy.event.detail.delete', {
            parent: 'board.dinghy.event.detail.overview',
            url: '/delete',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-delete-dialog.html',
                    controller: 'DinghyEventBoardDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event', null, { reload: 'board.dinghy.event' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.self-assign', {
            parent: 'board.dinghy.event.detail.overview',
            url: '/self-assign',
            data: {
                authorities: ['ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-assign-dialog.html',
                    controller: 'DinghyEventAssignController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.overview', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.cancel', {
            parent: 'board.dinghy.event.detail.overview',
            url: '/cancel',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-cancel-dialog.html',
                    controller: 'DinghyEventBoardCancelController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.overview', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.edit', {
            parent: 'board.dinghy.event.detail.overview',
            url: '/edit',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-dialog.html',
                    controller: 'DinghyEventBoardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
